import { Component, Element, Event, EventEmitter, Host, Prop, State, h } from '@stencil/core';

import { trackLandingVideo } from '../../../tracking/tracking.landing';

const MILESTONES = [75, 50, 25];

@Component({
  tag: 'video-player',
  styleUrl: 'video-player.css',
})
export class VideoPlayer {
  @Prop() fileUrl: string;
  @Prop() thumbnail: string;

  @Event() videoPause: EventEmitter<void>;

  @Element() host: HTMLElement;
  @State() milestoneReached: number = 0;
  @State() videoStarted: boolean = false;

  private videoElement: HTMLVideoElement;

  handlePlay() {
    if (!this.videoStarted) {
      trackLandingVideo('videoStart', 'click');
      this.videoStarted = true;
    }
  }

  handlePause() {
    this.videoPause.emit();
  }

  handleTimeUpdate() {
    const { currentTime, duration } = this.videoElement;
    const progress = (currentTime / duration) * 100;

    MILESTONES.forEach((milestone) => {
      if (progress >= milestone && milestone > this.milestoneReached) {
        trackLandingVideo('videoMilestone', 'view', milestone);
        this.milestoneReached = milestone;
      }
    });
  }

  handleEnded() {
    trackLandingVideo('videoComplete', 'view');
    this.milestoneReached = 0;
    this.videoStarted = false;
  }

  handleFullScreenChange() {
    if (document.fullscreenElement) {
      this.videoElement.style.objectFit = 'contain'; // Maintain aspect ratio in full-screen
    } else {
      this.videoElement.style.objectFit = 'cover'; // Reset to default when exiting full-screen
    }
  }

  componentDidLoad() {
    document.addEventListener('fullscreenchange', () => this.handleFullScreenChange());
  }

  disconnectedCallback() {
    document.removeEventListener('fullscreenchange', () => this.handleFullScreenChange());
  }

  render() {
    return (
      <Host>
        <div class="relative w-full aspect-video">
          <video
            class="absolute top-0 left-0 w-full h-full object-cover"
            ref={(el) => (this.videoElement = el)}
            src={this.fileUrl}
            poster={this.thumbnail}
            controls
            onPlay={() => this.handlePlay()}
            onPause={() => this.handlePause()}
            onTimeUpdate={() => this.handleTimeUpdate()}
            onEnded={() => this.handleEnded()}></video>
        </div>
      </Host>
    );
  }
}
